// Бегущая строка логотипов: считает, сколько айтемов должно быть видно
// на текущей ширине экрана, и прокидывает размеры в CSS-переменные.
// Разметка: components/section-partners.php, стили: src/scss/components/_marquee.scss.

// Опорные точки: на 390px видно 3.5 айтема, от 1284px (ширина контейнера) — 7.
// Между ними количество интерполируется линейно, за пределами — фиксируется.
const NARROW_VIEWPORT = 390;
const NARROW_COLUMNS_COUNT = 3.5;
const WIDE_VIEWPORT = 1284;
const WIDE_COLUMNS_COUNT = 12;

function getVisibleColumnsCount(viewportWidth, columnsCount = WIDE_COLUMNS_COUNT) {
    const ratio = (viewportWidth - NARROW_VIEWPORT) / (WIDE_VIEWPORT - NARROW_VIEWPORT);
    const clampedRatio = Math.min(Math.max(ratio, 0), 1);

    return NARROW_COLUMNS_COUNT + (columnsCount - NARROW_COLUMNS_COUNT) * clampedRatio;
}

export function marquee() {
    const $marquees = document.querySelectorAll(".site-marquee");
    if (!$marquees.length) return;

    const update = ($marquee) => {
        const columnsCount = $marquee.dataset.columnsCount || WIDE_COLUMNS_COUNT;
        const $wrap = $marquee.querySelector(".site-marquee__items-wrap");
        if (!$wrap) return;

        const ratio = (window.innerWidth - NARROW_VIEWPORT) / (WIDE_VIEWPORT - NARROW_VIEWPORT);
        const clampedRatio = Math.min(Math.max(ratio, 0), 1);

        const visibleColumnsCount = NARROW_COLUMNS_COUNT + (columnsCount - NARROW_COLUMNS_COUNT) * clampedRatio;

        $marquee.style.setProperty("--site-marquee-item-columns-count", visibleColumnsCount.toFixed(2));
        $marquee.style.setProperty("--site-marquee-viewport-width", `${$wrap.clientWidth}px`);
    };

    // ResizeObserver вместо window resize: реагирует и на изменения ширины
    // контейнера (появление скроллбара и т.п.), и срабатывает при инициализации.
    const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => update(entry.target.closest(".site-marquee")));
    });

    $marquees.forEach(($marquee) => {
        const $wrap = $marquee.querySelector(".site-marquee__items-wrap");
        if ($wrap) observer.observe($wrap);
    });
}
